import { render, staticRenderFns } from "./OOverridableNumberField.vue?vue&type=template&id=636814d4&scoped=true&"
import script from "./OOverridableNumberField.vue?vue&type=script&lang=js&"
export * from "./OOverridableNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636814d4",
  null
  
)

export default component.exports